"use strict";
exports.__esModule = true;
exports.StellarMemoType = exports.NetworkCongestionLevel = void 0;
var NetworkCongestionLevel;
(function (NetworkCongestionLevel) {
    NetworkCongestionLevel["LOW"] = "LOW";
    NetworkCongestionLevel["MEDIUM"] = "MEDIUM";
    NetworkCongestionLevel["HIGH"] = "HIGH";
})(NetworkCongestionLevel = exports.NetworkCongestionLevel || (exports.NetworkCongestionLevel = {}));
exports.StellarMemoType = [
    "NO_MEMO",
    "MEMO_TEXT",
    "MEMO_ID",
    "MEMO_HASH",
    "MEMO_RETURN",
];
//# sourceMappingURL=types.js.map